import { Dispatch } from 'redux';

import { setTermValue } from './advanced/term';

export function changeIsByHomeowner(value: boolean | undefined) {
  return (dispatch: Dispatch) => {
    dispatch(setTermValue('is_by_homeowner', value || undefined));
  };
}
